import React from 'react';
import { useForumTopicsList } from '@/api/forum/forum';
import { ForumTopic } from '@/api/opoint.schemas';
import ProjectList from '@/components/ProjectList';
import { ProjectPhase } from '@/constants';
import { ClipLoader } from 'react-spinners';

interface ProjectsProps {
  selectedTab: ProjectPhase;
}

const Projects: React.FC<ProjectsProps> = ({ selectedTab }: ProjectsProps) => {
  // Orval does not correctly convert the list of strings to ?tag=tag1&tag=tag2
  // so we have to cast it to unknown as string[] to avoid the error
  const {
    data: topics,
    isLoading,
    error: topicsError,
  } = useForumTopicsList({ tag: 'project' as unknown as string[] });

  let filteredTopics: ForumTopic[] = [];
  if (topics !== undefined) {
    filteredTopics = topics.filter((topic: ForumTopic) => {
      if (selectedTab === ProjectPhase.WONT_DO) {
        return (
          topic.closed &&
          topic.tags.some((tag: { name: string }) => tag.name === 'wont-do')
        );
      } else if (selectedTab === ProjectPhase.DONE) {
        return (
          topic.closed &&
          !topic.tags.some((tag: { name: string }) => tag.name === 'wont-do')
        );
      } else if (selectedTab === ProjectPhase.DOING) {
        return (
          !topic.closed &&
          topic.tags.some((tag: { name: string }) => tag.name === 'doing')
        );
      } else if (selectedTab === ProjectPhase.IDEA) {
        return (
          !topic.closed &&
          !topic.tags.some((tag: { name: string }) => tag.name === 'doing')
        );
      }
      return true;
    });
  }

  if (isLoading) {
    return (
      <div className='flex justify-center items-center h-screen'>
        <ClipLoader size={50} color={'black'} loading={isLoading} />
      </div>
    );
  }

  if (!topics || topicsError) {
    return <div>Error loading data</div>;
  }

  return (
    <div className='pt-12'>
      <ProjectList topics={filteredTopics} />
    </div>
  );
};

export default Projects;
